import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllCategorys = () => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_all_Categorys_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/category`);

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_all_Categorys_success',
            payload: {
                categorys: data.categorys,
                pagination:data.pagination,
             
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_all_Categorys_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};


export const getFillterCategorys = (page , limit ,titleAr,titleEn) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_categorys_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/category/filter`,{
            params: {
                page,
                limit,
                titleAr,
                titleEn,
                
            },
            withCredentials: true,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_categorys_success',
            payload: {
                categorys: data.categorys,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_categorys_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const getCategory = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_Categorys_request' });

        const { data } = await axios.get(`${BaseUrl}/category/${id}`);
 
        dispatch({ type: 'get_Categorys_success' ,payload:data.category});
    } catch (error) {
        dispatch({
            type: "get_Categorys_error",
            payload: error.response.data.message,
          });
    }
}


export const Clearcategory = () => async (dispatch) => {    
    dispatch({ type: 'clear_category' });
}